import React, { useState } from 'react';
import { useDisclosure } from '@mantine/hooks';
import {ReactComponent as EditIcon } from '../../assets/icons/Edit.svg'
import { RecipeDetailsListProps, PositionData } from '../../types/recipes';
import { Table, Button } from '@mantine/core';
import TableMedusa from '../../components/Table';
import RecipeDetailsPopUp from './recipeDetailsPopUp';

const RecipeDetailsList = ({data, onSave, colorOpt, recyclingOpt, reuseOpt, textileOpt,colorLabelOpt}:RecipeDetailsListProps) =>{
    const [editingHopper, setEditingHopper] = useState<PositionData|undefined>(undefined);
    const [opened, { open, close }] = useDisclosure(false);

    const icon = <EditIcon width={19} height={19}></EditIcon>;

    const onClickEdit = (hopperID:number) =>{
    setEditingHopper(data.find((el) => el.id === hopperID));
    open();
    }   

    const rows = data.map(({id, position, product_color, colors, recycling_categories, reuse_categories})=>(
        <Table.Tr key={id}>
            <Table.Td>{position}</Table.Td>
            <Table.Td>{colorLabelOpt?.find(option => String(product_color) === option.value)?.label}</Table.Td>
            <Table.Td> {colors.map((color, index) => (
                       <div key={index}>{colorOpt.find(option => color === option.value)?.label}</div>))}
            </Table.Td>
            <Table.Td> {recycling_categories.map((type, index) => (
                       <div key={index}>{recyclingOpt.find(option => type === option.value)?.label}</div>))}
            </Table.Td>
            <Table.Td> {reuse_categories.map((type, index) => (
                       <div key={index}>{reuseOpt.find(option => type === option.value)?.label}</div>))}
            </Table.Td>
             <Table.Td>
                    <Button variant="transparent" onClick={()=>onClickEdit(id)}>{icon}</Button>
            </Table.Td>

        </Table.Tr>

    ));

    
    return(
        <div>
            <RecipeDetailsPopUp opened={opened} close={close} title={"Edit"} onSave={onSave} hopper={editingHopper} colorOpt={colorOpt} recyclingOpt={recyclingOpt} reuseOpt={reuseOpt} textileOpt={textileOpt} colorLabelOpt={colorLabelOpt}></RecipeDetailsPopUp>
            <TableMedusa headers={["Hopper", "Color Label", "Colors", "Recycling", "Reuse", "Textile"]} rows={rows}></TableMedusa>
        </div>
);
}

export default RecipeDetailsList